export class SortModel {
	OrderColumn: string;
	OrderColumnGuid: string;
	SortOrder: number;
}